/**
 * Extracts the subdomain from the current hostname
 * @returns {string|null} The subdomain or null if on the main domain
 */
export const getSubdomain = (): string | null => {
	const hostname = window.location.hostname;

	// Skip for localhost development
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		// For local development, we can use URL parameters to test subdomain functionality
		const urlParams = new URLSearchParams(window.location.search);
		const testSubdomain = urlParams.get('subdomain');
		if (testSubdomain) {
			return testSubdomain;
		}
		return null;
	}

	// Handle IP addresses (no subdomain)
	if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
		return null;
	} else {
		console.log('asdfasdfasfasdf');
	}

	// Extract subdomain from hostname
	const parts = hostname.split('.');

	// Check if we have more than 2 parts (subdomain.domain.tld)
	if (parts.length > 2) {
		// Return the subdomain (e.g., 'mystore')
		return parts[0];
	}

	return null;
};

// List of reserved subdomains that should not be treated as storefront subdomains
// IMPORTANT: Keep this synchronized with the backend list in /src/routes/v1/shops.ts
export const RESERVED_SUBDOMAINS = [
	'www',
	'app',
	'admin',
	'api',
	'blog',
	'docs',
	'help',
	'support',
	'vendready',
	'mail',
	'dashboard',
	'store',
	'shop',
	'billing',
	'account',
	'auth',
	'login',
	'signup',
	'register',
	'static',
	'assets',
	'images',
	'files',
	'media',
	'cdn',
	'test',
	'demo',
	'staging',
	'dev',
	'development',
	'prod',
	'production',
];

/**
 * Checks if the current URL is a valid storefront subdomain
 * @returns {boolean} True if on a valid storefront subdomain
 */
export const isSubdomain = (): boolean => {
	const subdomain = getSubdomain();
	const hostname = window.location.hostname;

	// Get the base domain from environment variable
	const websiteUrl = process.env.REACT_APP_WEBSITE_URL || 'https://vendready.store';
	const baseDomain = websiteUrl.replace(/^https?:\/\//, '');

	// Special case for www - www.domain should go to the main app
	if (hostname === `www.${baseDomain}` || hostname === baseDomain) {
		return false;
	}

	// Return false if no subdomain or subdomain is in the reserved list
	if (!subdomain || RESERVED_SUBDOMAINS.includes(subdomain.toLowerCase())) {
		return false;
	}

	return true;
};
